import type { PaginatedLoadingContextValue } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import type {
  RxQueryResult,
  UseRxQueryOptions,
} from "rxdb-hooks"
import { useRxData } from "rxdb-hooks"
import { useIsFetchingForQuery } from "./useIsFetchingForQuery"
import { useQueryFunction } from "./useQueryFunction"
import type { CollectionKey } from "src/types"

/*
 * a find function that also returns an isFetching property that stays
 * true until the loader has loaded all relevant info for this query
 */
export function useFindWithLoading<T>(
  loadingContextValue: PaginatedLoadingContextValue,
  collectionKey: CollectionKey,
  queryObject: MangoQuery<T>,
  options: Omit<UseRxQueryOptions, "json"> = {},
): RxQueryResult<T> {
  const queryFunction = useQueryFunction<T>(queryObject)
  const result = useRxData<T>(
    collectionKey,
    queryFunction,
    {
      ...options,
      json: true,
    },
  )

  // check to see if more data is being requested that might be relevant
  // to this query
  const isFetching = useIsFetchingForQuery(
    loadingContextValue,
    queryObject,
  )

  return {
    ...result,
    isFetching: isFetching || result.isFetching,
  }
}
